import { URLS } from '@/assets/environment/urls'
import axios from 'axios'

const TOKEN_REQUEST_TIMEOUT_MS = 15_000

export class KcProxy {
	public static exchangeAuthorizationCode = async ({
		code,
		codeVerifier,
		redirectUri,
	}: {
		code: string
		codeVerifier: string
		redirectUri: string
	}): Promise<{ accessToken: string; refreshToken: string | null } | null> => {
		try {
			const params = new URLSearchParams({
				grant_type: 'authorization_code',
				code,
				client_id: URLS.KC_USER,
				redirect_uri: redirectUri,
				code_verifier: codeVerifier,
			})

			const response = await axios.post(
				`${URLS.KC_URL}realms/${URLS.KC_REALM}/protocol/openid-connect/token`,
				params.toString(),
				{
					timeout: TOKEN_REQUEST_TIMEOUT_MS,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
				}
			)

			const accessToken: unknown = response.data?.access_token
			const nextRefreshToken: unknown = response.data?.refresh_token
			if (typeof accessToken !== 'string' || !accessToken) return null

			return {
				accessToken,
				refreshToken: typeof nextRefreshToken === 'string' ? nextRefreshToken : null,
			}
		} catch (error: unknown) {
			console.error('Error exchanging authorization code:', error)
			return null
		}
	}

	public static refreshTokens = async (
		refreshToken: string
	): Promise<{ accessToken: string; refreshToken: string | null } | null> => {
		try {
			const params = new URLSearchParams({
				grant_type: 'refresh_token',
				refresh_token: refreshToken,
				client_id: URLS.KC_USER,
			})

			const response = await axios.post(
				`${URLS.KC_URL}realms/${URLS.KC_REALM}/protocol/openid-connect/token`,
				params.toString(),
				{
					timeout: TOKEN_REQUEST_TIMEOUT_MS,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
				}
			)

			const accessToken: unknown = response.data?.access_token
			const nextRefreshToken: unknown = response.data?.refresh_token
			if (typeof accessToken !== 'string' || !accessToken) return null

			return {
				accessToken,
				refreshToken: typeof nextRefreshToken === 'string' ? nextRefreshToken : null,
			}
		} catch (error: unknown) {
			console.error('Error refreshing tokens:', error)
			return null
		}
	}

	public static refreshAccessToken = async (refreshToken: string): Promise<string | null> => {
		const tokens = await KcProxy.refreshTokens(refreshToken)
		return tokens?.accessToken ?? null
	}
}
